export function getSelectOptions(options) {
  return options.map(function (option) {
    return {
      key: option.value,
      value: option.value,
      text: option.label
    };
  });
}